import { FC, useEffect, useState } from "react";
import { Collapse } from "../../Collapse";
import { BioContainer, Summary, Title } from "./styled";
import { extractParagraphsFromHtml } from "../../../utils";

interface PersonBioProps {
    title?: string;
    content?: string;
}

export const PersonBio: FC<PersonBioProps> = ({
    title = 'Биография',
    content
 }) => {
    const [summary, setSummary] = useState<string>('');
    const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

     useEffect(() => {
        if (content?.length) {
            setSummary(extractParagraphsFromHtml(content, 2));
        }
    }, [content]);

    if (!content?.length) {
        return null;
    }

    return (
        <div className="flex flex-col items-center px-3 max-w-full" style={{ fontFamily: 'Roboto, sans-serif' }}>
            <Title>{title}</Title>
            <div>
                {isCollapsed && summary && <Summary
                    dangerouslySetInnerHTML={{ __html: summary }}
                />}
                <Collapse height={0} onStateChange={(open)=>setIsCollapsed(!open)}>
                    <div
                        dangerouslySetInnerHTML={{ __html: content }}
                        className="fcr-article text-xl"
                    >
                    </div>
                </Collapse>
            </div>
        </div>
    );
}
